import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HandoverImageComponent } from 'src/app/components/handover-image/handover-image.component';
import { Handover } from 'src/app/interfaces/handover';
import { HandoverRelation } from 'src/app/interfaces/handover-relation';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { ImageService } from 'src/app/services/image.service';
import { Image } from 'src/app/interfaces/image';
import {
  HANDOVER_TYPE_HO1_LOC_ID,
  HANDOVER_TYPE_HO2_LOC_ID,
  HANDOVER_TYPE_HO4_LOC_ID,
  HANDOVER_TYPE_HOG_LOC_ID,
} from 'src/app/handover-constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-location-wellhead-images',
  templateUrl: './handover-detail-location-wellhead-images.component.html',
  styleUrls: ['./handover-detail-location-wellhead-images.component.scss'],
  standalone: false,
})
export class HandoverDetailLocationWellheadImagesComponent implements OnInit {
  @Input() handover: Handover | undefined;
  @Input() handoverRelation: HandoverRelation | undefined;
  @Input() readOnlyContent!: boolean;

  wellheadImages: Image[] = [];
  imageLimit = 6;
  qtyImageRequired = 1;
  isLoadingImages = false;
  isHOLOC = false;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    public handoverService: HandoverService,
    public imageService: ImageService,
    public dialogService: DialogService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.handover?.handoverId) {
      this.isHOLOC = [
        HANDOVER_TYPE_HO2_LOC_ID,
        HANDOVER_TYPE_HO1_LOC_ID,
        HANDOVER_TYPE_HOG_LOC_ID,
        HANDOVER_TYPE_HO4_LOC_ID,
      ].includes(this.handover!.handoverTypeId!);
      this.getWellheadImages(
        this.handoverRelation && this.handoverRelation.handoverLocationId
          ? this.handoverRelation.handoverLocationId
          : this.handover!.handoverId!
      );
    }
  }

  attachImage(): void {
    if (this.handover?.handoverId) {
      this.imageService.endpointUrl = `${environment.urlBackend}/dhoapi/handovers/${this.handover.handoverId}/wellheads/images`;
      const dialogRef = this.dialogService.openImageUploadDialog(
        this.handover.handoverId,
        'Adjuntar foto o diagrama',
        500
      );
      dialogRef.afterClosed().subscribe((image) => {
        if (undefined != image) {
          this.wellheadImages.push(image);
        }
      });
    }
  }

  getWellheadImages(handoverId: number): void {
    this.isLoadingImages = true;
    this.handoverService
      .getWellheadImages(handoverId)
      .subscribe((values: Image[]) => {
        this.wellheadImages = values;
        this.isLoadingImages = false;
      });
  }

  deleteImage(image: Image, index: number): void {
    if (this.handover?.handoverId)
      this.imageService.endpointUrl = `${environment.urlBackend}/dhoapi/handovers/${this.handover.handoverId}/wellheads/images`;
    const dialogRef = this.dialogService.openConfirmDialog(
      'Cabezal',
      `¿Está seguro de que desea eliminar la imagen?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.isLoadingImages = true;
        this.imageService.deleteImage(image).subscribe((boolean) => {
          this.wellheadImages.splice(index, 1);
          this.isLoadingImages = false;
        });
      }
    });
  }

  openImage(image: Image): void {
    const dialogRef = this.dialog.open(HandoverImageComponent, {
      width: '700px',
      height: '600px',
      hasBackdrop: false,
      autoFocus: false,
      data: {
        image: image,
        title: 'Cabezal',
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('Datos generales de pozo ha sido cerrado');
    });
  }
}
